import { state } from '@/manager/billing/store/state';
import { getters } from '@/manager/billing/store/getters';
import { mutations } from '@/manager/billing/store/mutations';
import { actions } from '@/manager/billing/store/action';

export const billing = {
    state,
    getters,
    actions,
    mutations,
};
